import {
  CONNECT_LEAD_SUB,
  DEFAULT_CONNECT_SUCCESS_BULLETS,
  DEFAULT_CONNECT_SUCCESS_CLOSING,
} from './connectAppAssistantPayloadBody.js'

export function buildConnectAppAssistantBlocks({ title, iconUrl, description, toolkitSlug }) {
  const slug =
    typeof toolkitSlug === 'string' && toolkitSlug.trim()
      ? toolkitSlug.trim().toLowerCase()
      : undefined
  const connection = {
    type: 'appConnection',
    title,
    description,
    iconUrl,
    status: 'connect',
    successBullets: DEFAULT_CONNECT_SUCCESS_BULLETS,
    successClosing: DEFAULT_CONNECT_SUCCESS_CLOSING,
  }
  if (slug) connection.toolkitSlug = slug
  return [
    { type: 'heading', level: 3, content: 'Create new connection?' },
    { type: 'markdown', variant: 'muted', content: CONNECT_LEAD_SUB },
    connection,
  ]
}
